import { BaseService } from 'core/services';
import NikoPatientDetailRouteService from './NikoPatientDetailRouteService';

class NikoPatientDetailService extends BaseService {
    constructor(apiClient) {
        super(apiClient, new NikoPatientDetailRouteService());
    }

    updatePatientInformation(resource) {
        const url = this.routeService.updatePatientInformation(resource);
        const connectionId = sessionStorage.getItem("connectionId");
        return this.apiClient.put(url, resource, connectionId ? { connectionId: connectionId } : null);
    }

    updatePatientStatus(resource) {
        const url = this.routeService.updatePatientStatus(resource);
        return this.apiClient.put(url, resource);
    }

    updatePatientFacility(resource) {
        const url = this.routeService.updatePatientFacility(resource);
        return this.apiClient.put(url, resource);
    }

    updatePatientInsuranceInfo(resource) {
        const url = this.routeService.updatePatientInsuranceInfo(resource);
        return this.apiClient.put(url, resource);
    }

    downloadReport(resource) {
        return this.apiClient.appOptions.apiUrl + this.routeService.downloadReport(resource);
    }

    downloadPsoReport(resource) {
        return this.apiClient.appOptions.apiUrl + this.routeService.downloadPsoReport(resource);
    }

    updateNikoPatientReasonForChange(resource) {
        const url = this.routeService.updateNikoPatientReasonForChange(resource);
        return this.apiClient.put(url, resource);
    }

    precheckNikoPatientReasonForChange(resource) {
        const url = this.routeService.precheckNikoPatientReasonForChange(resource);
        return this.apiClient.post(url, resource);
    }

    deleteNikoPatientDetailInsurance(resource) {
        const url = this.routeService.deleteNikoPatientDetailInsurance(resource);
        return this.apiClient.delete(url, null, resource);
    }

    updateNikoPatientDetailInsurance(resource) {
        const url = this.routeService.updateNikoPatientDetailInsurance(resource);
        return this.apiClient.put(url, resource);
    }

    createNikoPatientDetailInsurance(resource) {
        const url = this.routeService.createNikoPatientDetailInsurance(resource);
        return this.apiClient.post(url, resource);
    }

    getEligibilityStatusNote(resource) {
        const url = this.routeService.getEligibilityStatusNote(resource);
        return this.apiClient.post(url, resource);
    }
}

export default NikoPatientDetailService;